import {getArea} from '../../node_modules/ol/sphere.js';
import formatNumWithCommas from './formatNumWithCommas.js';

/**
 * @param {ol.geom.Polygon} An ol3 polygon
 * @return {string} returns an area label AND sets geom's areaLabel so that it won't have to be calculated next time
 */
export default function (polygon) {
  // use spherical getArea() or Cartesian polygon.getArea()
  let area = rwg.config.geodesic ? getArea(polygon) * 10.7639 : polygon.getArea()
  let out = ''
  if (area > 1) {
    let acres = area / 43560;
    let sqMile = acres / 640;
    if (area < 43560) {
      out += formatNumWithCommas(acres.toFixed(2)) + ' ac'
      if (!rwg.config.hideSqFt) {
        out += ', ' + formatNumWithCommas(Math.round(area)) + ' sq ft'
      }
    } else if (acres >= 1 && sqMile < 1) {
      out += formatNumWithCommas(acres.toFixed(1)) + ' ac'
    } else if (sqMile >= 1) {
      out += formatNumWithCommas(acres.toFixed(1)) + ' ac, '+
      formatNumWithCommas(sqMile.toFixed(2)) + ' sq miles';
    }
  }
  polygon.set('areaLabel', out);
  return out;
}
